/****
 * 老门户社交媒体
 */
export default [
    {
        path: '/manageP/sns',
        name: 'managepanel-sns',
        component: () => import('@@/views/market/socialMedia'),
        meta: {
            title: '社交媒体',
        },
        children: [
            {
                path: 'publish',
                name: 'managepanel-sns-publish',
                meta: { title: '内容发布'},
                component: () => import('@@/views/market/socialMedia/publish/index.vue'),
            },
            {
                path: 'account',
                name: 'managepanel-sns-account',
                meta: { title: '社交媒体绑定'},
                component: () => import('@@/views/market/socialMedia/account/index.vue'),
            },
            {
                path: 'publish/add',
                name: 'managepanel-sns-publish-add',
                meta: { title: '内容发布' },
                component: () => import('@@/views/market/socialMedia/publish/add/index.vue'),
            },
            {
                path: 'analysis',
                name: 'managepanel-sns-analysis',
                meta: { title: '数据监测'},
                component: () => import('@@/views/market/socialMedia/analysis/index.vue'),
            },
            {
                path: 'analysis/pagedata',
                name: 'managepanel-sns-analysis-pagedata',
                meta: { title: '数据监测'},
                component: () => import('@@/views/market/socialMedia/analysis/pagedata.vue'),
            },
        ]
    },
];
